<script lang="ts">

import { defineComponent } from 'vue'

export default defineComponent({
  data() {
    return {
        // icon:{ type:String, default:"home"},
        // text:{ type:String, default:"Go Home"}
    }
  },
  methods:{
    AddOne()
    {
        // this.count++;
    }, 
  },
  mounted(){
    console.log("Category mounted");
  },
  props:{
    icon:{ type:String, default:"home"},
    text:{ type:String, default:"Go Home"},
    color_bg:{ type:String, default:"purple"},
    color_txt:{ type:String, default:"white"}
    },

    //computed- so we can pass variables into css without having to do javascript
    //from: https://stackoverflow.com/questions/42872002/in-vue-js-component-how-to-use-props-in-css
  computed: {
    cssProps() {
        // console.log("color is: ", this.bg_color);
      return {
        // '--hover-font-size': (this.baseFontSize * 2) + "em",
        
        '--bg-color': this.color_bg,
        '--txt-color': this.color_txt,
        // '--hover-content': JSON.stringify(this.hoverContent)
      }
    }
  }
})
</script>

<template >
<div class="category" :style="cssProps">
    <span class="gradient"></span>
    <span class="highlight"></span>
    
    <div class="content">
      <span class="material-symbols-outlined">{{icon}}</span>
      <p>{{ text }}</p>
    </div>
    
</div>
</template>

<style scoped>


.category
{
    padding: 20px;
    /* background-color: #777; */
    color:var(--txt-color);
    
    text-align: center;
    background-color:var(--bg-color);
    transition: all 100ms;
    transform: scale(1);
    margin:10px;
    user-select: none;
    cursor: pointer;

    position: relative;
    
    border-radius: 10px;
    /* aspect-ratio: 1; */
    /* width:100px;
    height:100px; */
    min-width:.5in;
    min-height:.5in;
    /* max-width:1in; */
    /* height:1in */
    /* height:2in;
    width:3in; */

    display: flex;
    justify-content: center;
    align-items: center;

}
.gradient
{
    background: linear-gradient(rgba(255, 255, 255, 0), rgba(255, 255, 255, .2));
    position:absolute;
    width:90%;
    height:90%;
    top:5%;
    left:5%;
    border-radius: 10px;
}
.highlight
{
    background: linear-gradient(rgba(255, 255, 255, .3), rgba(255, 255, 255, 0));
    position:absolute;
    width:90%;
    height:90%;
    top:5%;
    left:5%;
    border-radius: 10px;
    height:20%;
}

.category:hover
{
    transform: scale(1.2);
}

.material-icons-outlined {
    
    -moz-osx-font-smoothing: grayscale;

  font-variation-settings:
  'FILL' 0,
  'wght' 300,
  'GRAD' 0,
  'opsz' 24;
  font-size:48px;
}
/* .content
{
  position: absolute;
  top:50%;
  left:50%;
  transform: translate(-50%, -50%);
} */

</style>